/**
 * @Description 详情操作按钮
 */

import V2Operate from '@/common/components/Others/V2Operate';
import React, { useMemo, useRef, useState } from 'react';
import { useMethods } from '@lhb/hook';
import { refactorPermissions, getJurisList } from '@lhb/func';
import V2Title from '@/common/components/Feedback/V2Title';
import ChangeStatusModal from '../../shop/components/ChangeStatusModal';
import V2Message from '@/common/components/Others/V2Hint/V2Message';
import ShopEditDrawer from '../../shopEdit/Drawer';
import AdaptiveTaskDetail from '@/common/components/business/ExpandStore/AdaptiveTaskDetail';
import styles from './index.module.less';

const targetBtnEvents = [ // 指定的按钮
  'standardShop:task',
  'standardShop:changeStatus',
  'standardShop:edit',
];
const DetailTitle: React.FC<{
   reload, detail
}> = ({ reload, detail }) => {
  const editRef: any = useRef();
  const detailRef: any = useRef();
  const [statusVisible, setStatusVisible] = useState<boolean>(false); // 变更状态

  // https://confluence.lanhanba.com/pages/viewpage.action?pageId=119174088
  // UI要求的按钮排序 顺序由左往右 拓店任务，变更状态，编辑（蓝色高亮）
  const operationBtns = {
    'task': true, // 拓店任务
    'changeStatus': true, // 变更状态
    'statusRecord': true, // 场地下架
    'edit': { type: 'primary', }, // 编辑
  };

  const methods = useMethods({
    handleEdit() {
      editRef.current?.init(detail.id);
    },
    handleChangeStatus() {
      setStatusVisible(true);
    },
    handleTask() {
      // 数据来源 1:系统生成 2:导入
      if (detail.origin === 2) {
        V2Message.warning('导入数据无拓店任务可查看');
        return;
      }
      (detailRef.current as any).handleTaskDetail(detail.taskId);
    },
  });

  const operateList = useMemo(() => {
    // https://confluence.lanhanba.com/pages/viewpage.action?pageId=119174088
    // UI要求的按钮排序 顺序由左往右 拓店任务，变更状态，编辑（蓝色高亮）
    const { permissions } = detail || {};
    let sortPermissions: any[] = [];
    const taskBtn = permissions?.find((item) => item.event === 'standardShop:task');
    taskBtn && sortPermissions.push(taskBtn);
    const changeStatusBtn = permissions?.find((item) => item.event === 'standardShop:changeStatus');
    changeStatusBtn && sortPermissions.push(changeStatusBtn);
    const editBtn = permissions?.find((item) => item.event === 'standardShop:edit');
    editBtn && sortPermissions.push(editBtn);
    // 如果还有其他的按钮，那就放前面
    const otherBtn = permissions?.filter((item) => !targetBtnEvents.includes(item.event));
    otherBtn?.length > 0 && (sortPermissions = otherBtn.concat(sortPermissions));
    return getJurisList(operationBtns, refactorPermissions(sortPermissions), methods);
  }, [detail.permissions]);

  return (
    <>
      <V2Title
        type='H1'
        text='门店详情'
        extra={
          <V2Operate operateList={operateList} />
        }
        className={styles.shopDetailTitle}
      />

      {/* 编辑 */}
      <ShopEditDrawer ref={editRef} reload={reload}/>

      {/* 变更状态 */}
      <ChangeStatusModal visible={statusVisible} setVisible={setStatusVisible} record={detail} onRefresh={reload}/>

      {/* 拓店任务 */}
      <AdaptiveTaskDetail ref={detailRef} reload={reload}/>
    </>
  );
};

export default DetailTitle;
